import styled from 'styled-components'

export const LocationEditModalWrapper = styled.div``



// WEBPACK FOOTER //
// ./src/Components/City/Page/Locations/Modals/LocationEditModalWrapper/index.js